<template>
  <div
    class="container-fluid"
    :class="$style.container"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
});
</script>

<style lang="scss" module>
@import '../styles/variables-entry';
.container {
  max-width: map-get($container-max-widths, lg);
}
</style>
